module.exports = __webpack_public_path__ + "img/motivating-productivity.fadc91f3.svg";